import { render, staticRenderFns } from "./ImportProposalUploader.vue?vue&type=template&id=5b28b28b&scoped=true"
import script from "./ImportProposalUploader.vue?vue&type=script&lang=js"
export * from "./ImportProposalUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28b28b",
  null
  
)

export default component.exports